/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListToolVariationGroupsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListToolVariationGroupsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListToolVariationGroupsSecurity = {
  option1?: ListToolVariationGroupsSecurityOption1 | undefined;
  option2?: ListToolVariationGroupsSecurityOption2 | undefined;
};

export type ListToolVariationGroupsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListToolVariationGroupsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListToolVariationGroupsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListToolVariationGroupsSecurityOption1$Outbound,
    ListToolVariationGroupsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listToolVariationGroupsSecurityOption1ToJSON(
  listToolVariationGroupsSecurityOption1:
    ListToolVariationGroupsSecurityOption1,
): string {
  return JSON.stringify(
    ListToolVariationGroupsSecurityOption1$outboundSchema.parse(
      listToolVariationGroupsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListToolVariationGroupsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListToolVariationGroupsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListToolVariationGroupsSecurityOption2$Outbound,
    ListToolVariationGroupsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listToolVariationGroupsSecurityOption2ToJSON(
  listToolVariationGroupsSecurityOption2:
    ListToolVariationGroupsSecurityOption2,
): string {
  return JSON.stringify(
    ListToolVariationGroupsSecurityOption2$outboundSchema.parse(
      listToolVariationGroupsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListToolVariationGroupsSecurity$Outbound = {
  Option1?: ListToolVariationGroupsSecurityOption1$Outbound | undefined;
  Option2?: ListToolVariationGroupsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListToolVariationGroupsSecurity$outboundSchema: z.ZodMiniType<
  ListToolVariationGroupsSecurity$Outbound,
  ListToolVariationGroupsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListToolVariationGroupsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListToolVariationGroupsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listToolVariationGroupsSecurityToJSON(
  listToolVariationGroupsSecurity: ListToolVariationGroupsSecurity,
): string {
  return JSON.stringify(
    ListToolVariationGroupsSecurity$outboundSchema.parse(
      listToolVariationGroupsSecurity,
    ),
  );
}

/** @internal */
export type ListToolVariationGroupsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListToolVariationGroupsRequest$outboundSchema: z.ZodMiniType<
  ListToolVariationGroupsRequest$Outbound,
  ListToolVariationGroupsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listToolVariationGroupsRequestToJSON(
  listToolVariationGroupsRequest: ListToolVariationGroupsRequest,
): string {
  return JSON.stringify(
    ListToolVariationGroupsRequest$outboundSchema.parse(
      listToolVariationGroupsRequest,
    ),
  );
}
